import React, { FC, useMemo } from 'react';

interface ITextWithBreaksProps {
	text: string;
	prefix: string;
}

export const TextWithLineBreaks: FC<ITextWithBreaksProps> = ({ text, prefix }) => {
	const textWithBreaks = useMemo(
		() =>
			text.split('\n').map((text, index) => (
				<React.Fragment key={`${index}-${prefix}`}>
					{text}
					<br />
				</React.Fragment>
			)),
		[text]
	);

	return <>{textWithBreaks}</>;
};
